<div
  appConfigSettingsBackground
  class="summary-insurance-container"
  [ngClass]="{'mobileAllowed': isMobile, 'opened': isReceiptOpen, 'closed': !isReceiptOpen}"
>
  <div class="summary-insurance-data">
    <div class="secondTitle premium-block-title">
      <h2
        class="desktop-title"
        appConfigSettingsBackground
      >
        {{title | translate}}
      </h2>
      <h2
        class="mobile-title"
        appConfigSettingsBackground
        *ngIf="isReceiptOpen"
      >
        {{title | translate}}
      </h2>
      <p
        class="mobile-title mobile-title-closed"
        appConfigSettingsBackground
        *ngIf="!isReceiptOpen"
      >
        <span>{{'PremiumBlock.MobileTitle' | translate}}</span>
        <span class="mobile-title-premium">€{{monthlyPremium}}</span>
      </p>
      <div
        (click)="switchReceiptMenu()"
        class="menu-control"
      >
        <mat-icon *ngIf="!isReceiptOpen">expand_more</mat-icon>
        <mat-icon *ngIf="isReceiptOpen">close</mat-icon>
      </div>
    </div>
    <div class="summary-insurance-data-row" *ngIf="isORVProduct">
      <div class="summaryLabel">{{'ClosingStatement.Name' | translate}}</div>
      <div class="summaryValue">{{name}}</div>
    </div>
    <div class="summary-insurance-data-row" *ngIf="isGGProduct">
      <div class="summaryLabel">{{'ClosingStatement.Occupation' | translate}}</div>
      <div class="summaryValue">{{occupation}}</div>
    </div>
    <div class="summary-insurance-data-row">
      <div class="summaryLabel">{{'ClosingStatement.Birthdate' | translate}}</div>
      <div class="summaryValue">{{birthDate | date:'dd-MM-yyyy'}}</div>
    </div>
    <div class="summary-insurance-data-row">
      <div class="summaryLabel" *ngIf="isORVProduct">{{'ClosingStatement.InsuredAmount' | translate}}</div>
      <div class="summaryLabel" *ngIf="isGGProduct">{{'ClosingStatement.InsuredMonthlyCost' | translate}}</div>
      <div class="summaryValue">{{insuredAmount | currency:'EUR':'symbol':'0.2-2':'nl'}}</div>
    </div>
    <div class="summary-insurance-data-row" *ngIf="isGGProduct">
      <div class="summaryLabel">{{'ClosingStatement.ClaimAssessmentFromSecondYear' | translate}}</div>
      <div class="summaryValue">{{(isOwnLabour === 'YES' ? 'ClosingStatement.IsOwnLabourYes' : 'ClosingStatement.IsOwnLabourNo') | translate}}</div>
    </div>
    <div *ngIf="isORVProduct && isSecondInsured">&nbsp;</div>
    <div class="summary-insurance-data-row" *ngIf="isORVProduct && isSecondInsured">
      <div class="summaryLabel">{{'ClosingStatement.NameSecondInsured' | translate}}</div>
      <div class="summaryValue">{{secondInsuredName}}</div>
    </div>
    <div class="summary-insurance-data-row" *ngIf="isORVProduct && isSecondInsured">
      <div class="summaryLabel">{{'ClosingStatement.Birthdate' | translate}}</div>
      <div class="summaryValue">{{secondInsuredBirthDate | date:'dd-MM-yyyy'}}</div>
    </div>
    <div class="summary-insurance-data-row" *ngIf="isORVProduct && isSecondInsured">
      <div class="summaryLabel">{{'ClosingStatement.InsuredAmount' | translate}}</div>
      <div class="summaryValue">{{secondInsuredInsuredAmount | currency:'EUR':'symbol':'0.2-2':'nl'}}</div>
    </div>
    <div>&nbsp;</div>
    <div class="summary-insurance-data-row" *ngIf="isORVProduct">
      <div class="summaryLabel">{{'ClosingStatement.TermOfInsurance' | translate}}</div>
      <div class="summaryValue">{{termOfProduct}} {{'ClosingStatement.Years' | translate}}</div>
    </div>
    <div class="summary-insurance-data-row" *ngIf="isGGProduct">
      <div class="summaryLabel">{{'ClosingStatement.Benefit' | translate}}</div>
      <div class="summaryValue">{{claimDuration}}</div>
    </div>
    <div class="summary-insurance-data-row" *ngIf="isORVProduct">
      <div class="summaryLabel">{{'ClosingStatement.TypeOfCover' | translate}}</div>
      <div class="summaryValue">{{typeOfBenefit}}</div>
    </div>
    <div class="summary-insurance-data-row" *ngIf="isORVProduct && annuityRate">
      <div class="summaryLabel">{{'ClosingStatement.AnnuityRate' | translate}}</div>
      <div class="summaryValue">{{annuityRate}}%</div>
    </div>
    <div *ngIf="isORVProduct">&nbsp;</div>
    <div class="summary-insurance-data-row">
      <div class="summaryLabel">{{'ClosingStatement.StartDate' | translate}}</div>
      <div class="summaryValue">{{startDate | date:'dd-MM-yyyy'}}</div>
    </div>
    <div class="summary-insurance-data-row">
      <div class="summaryLabel">{{'ClosingStatement.EndDate' | translate}}</div>
      <div class="summaryValue">{{endDate | date:'dd-MM-yyyy'}}</div>
    </div>
    <div class="summary-insurance-data-row" *ngIf="isGGProduct && showProductDetails">
      <div class="summaryLabel">{{'ProductInfo.RiskDuration' | translate}}</div>
      <div class="summaryValue">{{waitingPeriod}}</div>
    </div>
    <div  *ngIf="isGGProduct && showProductDetails">&nbsp;</div>
    <div class="summary-insurance-data-row" *ngIf="isGGProduct && showProductDetails">
      <div class="summaryLabel">{{'ProductInfo.MentalIllnessReceipt' | translate}}</div>
      <div class="summaryValue">{{mentalIllness | translate}}</div>
    </div>
    <div class="summary-insurance-data-row" *ngIf="isGGProduct && showProductDetails">
      <div class="summaryLabel">{{'ProductInfo.IndexationUsageReceipt' | translate}}</div>
      <div class="summaryValue">{{indexationUsage | translate}}</div>
    </div>
    <div class="summary-insurance-data-row" *ngIf="showIntermediaryFee">
      <div class="summaryLabel">{{parseTemplatedStatement('ClosingStatement.MediationFee', 'name_intermediary')
      + ' ' + intermediaryFeePeriod}}</div>
      <div class="summaryValue">{{intermediaryFee | currency:'EUR':'symbol':'0.2-2' : 'nl'}}</div>
    </div>
    <div class="summary-insurance-data-row" *ngIf="showIntermediarySubscriptionFee">
      <div class="summaryLabel">{{(intermediarySubscriptionFeeText ? intermediarySubscriptionFeeText + ' ' : '') + ('Calculator.SubscriptionFees' | translate) + ' ' + intermediarySubscriptionFeePeriod?.toLowerCase() + ' ' + parseTemplatedStatement(
        'PremiumBlock.SubscriptionIntermediaryDetails', 'name_intermediary')}}
      </div>
      <div class="summaryValue">{{intermediarySubscriptionFee | currency:'EUR':'symbol':'0.2-2' : 'nl'}}</div>
    </div>
    <div class="closingText" [innerHTML]="closingText"></div>
  </div>
  <div class="summary-insurance-premium">
    <div class="premiumContainer">
      <div class="premium-euros">
        <span class="premium-euros-sign">€</span>
        <span class="premium-euros-value">{{math.floor(monthlyPremium)}}</span>
      </div>
      <div class="premium-coins">,{{monthlyPremium?.toFixed(2).toString().split('.')[1]}}</div>
      <div class="premium-label">{{'ClosingStatement.PerMonth' | translate}}</div>
    </div>
  </div>
  <div class="summary-insurance-button" *ngIf="showControls">
    <div class="buttons-control-container">
      <ng-container *ngIf="checkIsPremiumsCalculated">
        <button
          class="primary"
          type="button"
          (click)="handleDownloadQuote()"
          [style.color]="configSettings.backgroundColor"
          [style.background]="configSettings.backgroundTextColor"
          style.border="none"
        >
          {{ "Calculation.Quote" | translate }}
        </button>
      </ng-container>
    </div>
    <div class="buttons-control-container">
      <button
        class="primary premiumBlockSubmitApplicationBtn"
        (click)="submitApplication()"
        [disabled]="false"
        [style.color]="isStatementsAgreed ? configSettings.backgroundColor : configSettings.backgroundTextColor"
        [style.background]="isStatementsAgreed ? configSettings.backgroundTextColor : configSettings.backgroundColor"
        [style.border]="isStatementsAgreed ? 'none' : 'solid 1px ' + configSettings.backgroundTextColor"
      >
        {{'ApplicationPage.Apply' | translate}}
      </button>
    </div>
  </div>
  <div *ngIf="isDiscountTextShown" class="discountText">
    {{ 'ProductInfo.DiscountText' | translate }}
  </div>
  <div *ngIf="isShowCalculatePremiumText" class="discountText">
    {{ 'ProductInfo.DiscountTextForCalculate' | translate }}
  </div>
</div>
